import HrSelfService from "../../pages/HrSelfService/hrSelfService"

export const hrSelfServiceRoutes = [
  { path: "/hr-self-service", component: <HrSelfService /> },
]
